import { createRouter, createWebHashHistory } from 'vue-router'
import routes from './routes'
import { setupRouterGuards } from './guards'

/**
 * 创建路由实例
 */
const router = createRouter({
  // 使用hash模式，适合Electron应用
  history: createWebHashHistory(),
  // 引入路由表
  routes,
  // 滚动行为配置
  scrollBehavior: () => ({ left: 0, top: 0 })
})

/**
 * 配置路由守卫
 */
setupRouterGuards(router)

/**
 * 导出路由实例
 */
export default router

/**
 * 导出安装路由的函数，用于在main.ts中使用
 */
export function setupRouter(app) {
  app.use(router)
}